// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"255":"test","389":"404","962":"home"}[chunkId] || chunkId) + "." + {"255":"eec1c703","389":"c6fa9534","855":"b9cd87e9","962":"0282d4fa"}[chunkId] + ".js";
};